import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface HeaderContentProps {
  children: React.ReactNode;
  logoPosition: 'left' | 'right' | 'center';
}

const HeaderContentComponent: React.FC<HeaderContentProps> = ({
  children,
  logoPosition,
}) => {
  return (
    <div
      className={`peptalk-chat-header-content peptalk-chat-header-content-${logoPosition}`}
    >
      {children}
    </div>
  );
};

export const HeaderContent: React.FC<HeaderContentProps> = (
  props: HeaderContentProps
) => {
  const Component = useCustomComponent({
    componentName: 'HeaderContent',
    Component: HeaderContentComponent,
  });

  return <Component {...props} />;
};
